import {Component, Input} from "@angular/core";
import {ALL_ROLES} from "./workflow.service";
import {KeyByObject} from "../misc/reduce-helpers";

const rolesAbbreviationMap = ALL_ROLES
  .reduce((obj, role) => obj.add(role.key, role.abbreviation), new KeyByObject())
  .toObject();

const allowedComboClasses: {[key: string]: boolean} = {
  "transition-lead-account-lead": true,
  "transition-lead-product-support-specialist": true,
  "contract-administrator-product-support-specialist": true,
  "delivery-consultant-product-support-specialist": true,
  "delivery-consultant-delivery-admin-management": true,
};

const rolesKeys = ALL_ROLES.map(it => it.key);

@Component({
  selector: "role-block",
  templateUrl: "./role-block.template.pug",
})
export class RoleBlockComponent {
  private roleList: string[];

  hidden: boolean = false;
  multi: boolean;
  text: string;
  cssClass: string;
  expandableRoleList: {cssClass: string, abbreviation: string}[];

  @Input("expandDirection")
  expandDirection: string = "right";

  @Input("stacking")
  stacking: boolean = false;

  @Input("extraCss")
  extraCss: string = "";

  @Input("roles")
  set roles(roles: string[]) {
    this.roleList = roles || [];
    this.processRoles();
  }

  get roles(): string[] {
    return this.roleList;
  }

  private processRoles() {
    this.hidden = false;
    const roleList = rolesKeys.filter(key => this.roleList.includes(key));

    this.expandableRoleList = roleList.map(it => ({cssClass: it, abbreviation: rolesAbbreviationMap[it]}));

    if (this.roleList.includes("developer-access")) {
      this.multi = false;
      this.text = "IT";
      this.cssClass = "it-support";
      return;
    }

    if (this.roleList.includes("super-user")) {
      this.multi = false;
      this.text = "ADMIN";
      this.cssClass = "super-user";
      return;
    }

    switch (roleList.length) {
      case 0:
        this.multi = false;
        this.text = "NONE";
        this.cssClass = "";
        this.hidden = true;
        break;
      case 1:
        this.multi = false;
        this.text = rolesAbbreviationMap[roleList[0]];
        this.cssClass = roleList[0];
        break;
      case 2:
        this.multi = false;
        this.text = `${rolesAbbreviationMap[roleList[0]]}/${rolesAbbreviationMap[roleList[1]]}`;
        this.cssClass = allowedComboClasses[`${roleList[0]}-${roleList[1]}`] ?
          `${roleList[0]}-${roleList[1]}` :
          roleList[0];
        break;
      default:
        this.multi = true;
        this.text = "MULTI";
        this.cssClass = "";
        break;
    }
  }

  constructor() {
    this.roles = [];
  }
}
